import React from 'react'
import styled from 'styled-components'

export const AccessibleText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const AccessibleLabel = AccessibleText.withComponent('label')



// WEBPACK FOOTER //
// ./src/components/ScreenReader.js